function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M61.6699 7.5C63.5944 4.16667 68.4056 4.16667 70.3301 7.5L118.828 91.5C120.752 94.8333 118.346 99 114.497 99H17.5026C13.6536 99 11.2479 94.8333 13.1725 91.5L61.6699 7.5Z",
  fill: "#0056D2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M71.4902 35.2344L70.499 70.0635H62.877L61.8857 35.2344H71.4902ZM61.6123 80.7959C61.6123 79.4515 62.068 78.3236 62.9795 77.4121C63.9137 76.4779 65.167 76.0107 66.7393 76.0107C68.3115 76.0107 69.5534 76.4779 70.4648 77.4121C71.3991 78.3236 71.8662 79.4515 71.8662 80.7959C71.8662 82.1175 71.3991 83.234 70.4648 84.1455C69.5534 85.057 68.3115 85.5127 66.7393 85.5127C65.167 85.5127 63.9137 85.057 62.9795 84.1455C62.068 83.234 61.6123 82.1175 61.6123 80.7959Z",
  fill: "white"
});

function SvgActivationFailedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivationFailedIcon);
export default __webpack_public_path__ + "static/media/activation-failed-icon.813efdde.svg";
export { ForwardRef as ReactComponent };